import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';
// auth
import {AuthGuard} from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import {LoadingScreen} from 'src/components/loading-screen'

const EndpointsPage = lazy(() => import('src/pages/endpoints/EndpointsPage'));

export const endpointsRoutes = [
  {
    path: '/endpoints',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <EndpointsPage />,
      },
      {
        path: 'view/:id',
        element: <EndpointsPage />,
      },
    ],
  },
];
